export default "__VITE_ASSET__2nn_gR7d__"